import styled from "styled-components";
import { IconButton } from "@material-ui/core";
import { ChevronRight } from "@material-ui/icons";

export const Wrapper = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }
`;

export const LeftContentWrapper = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: ${props => props.padding || "0"};
  }
`;

export const IconWrapper = styled.div`
  && {
    padding: 0 1em;
  }
`;

export const StyledIconButton = styled(IconButton)`
  && {
    color: #005aa9 !important;
  }
`;

export const NameTypeWrapper = styled.div`
  && {
    display: flex;
    flex-direction: column;
  }
`;

export const NameWrapper = styled.div`
  && {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    padding: 3px 0;
  }
`;

export const TypeWrapper = styled.div`
  && {
    color: #5f6368;
    font-size: 14px;
    font-weight: 400;
  }
`;

export const RightContentWrapper = styled.div`
  && {
    align-items: center;
    cursor: pointer;
    display: flex;
    justify-content: flex-end;
    padding: 0 1em;
    text-align: right;
  }
`;

export const LevelWrapper = styled.div`
  && {
    color: #005aa9;
    font-size: 14px;
    font-weight: 500;
    padding-right: 1em;
  }
`;

export const StyledChevronRight = styled(ChevronRight)`
  && {
    color: #005aa9;
  }
`;

export const StyledDate = styled.div`
  color: ${props => props.color || "black"};
  font-size: ${props => props.size || "14px"};
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  line-height: 130%;
  padding: 3px 0;
`;
